var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { AuthClient, RecaptchaClient, RequestUserPasswordResetCommand, UserPasswordResetRequestModel, RecaptchaRequestViewModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { AppConfigState } from "@/app/store/modules/appconfig.state";
import { load } from "recaptcha-v3";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const authClient = new AuthClient(window.apiUrl);
const recaptchaClient = new RecaptchaClient(window.apiUrl);
const changeRecaptchaVisibility = (show) => {
    let badge = document.getElementsByClassName("grecaptcha-badge")[0];
    if (!badge)
        return;
    badge.style.visibility = show ? "visible" : "hidden";
};
let ForgottenPasswordVue = class ForgottenPasswordVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.requestReceived = false;
        this.working = false;
        this.userName = "";
        // recaptcha
        this.recaptcha = null;
    }
    // methods
    created() {
        if (this.appConfigState.recaptchaSiteKey) {
            try {
                load(this.appConfigState.recaptchaSiteKey).then(recaptcha => {
                    this.recaptcha = recaptcha;
                    changeRecaptchaVisibility(true);
                });
            }
            catch (ex) {
                console.error(ex);
            }
        }
    }
    ;
    beforeRouteEnter(to, from, next) {
        changeRecaptchaVisibility(true);
        next();
    }
    ;
    beforeRouteLeave(to, from, next) {
        changeRecaptchaVisibility(false);
        next();
    }
    ;
    requestPasswordReset() {
        const handleSubmitAction = this.handleSubmit(() => {
            if (!this.appConfigState.recaptchaSiteKey) {
                this.submitPasswordRequest();
                return;
            }
            if (!this.recaptchaLoaded || !this.recaptcha)
                return;
            try {
                this.recaptcha.execute(`requestPasswordReset`)
                    .then(token => {
                    if (!token)
                        throw new Error(`Received empty token.`);
                    recaptchaClient
                        .validate(new RecaptchaRequestViewModel({ response: token, action: "requestPasswordReset" }))
                        .then(response => {
                        if (!response.isValid) {
                            console.warn(`This request has been flagged as suspicious by Google reCaptcha. Try reloading the page.`);
                            Notifier.onWarning(`This request has been flagged as suspicious by Google reCaptcha. Try reloading the page.`);
                            return;
                        }
                        this.submitPasswordRequest();
                    })
                        .catch(ex => {
                        HttpHelper.handleResponse(ex, () => {
                            Notifier.onServerError(ex);
                        });
                    });
                });
            }
            catch (ex) {
                Notifier.onError(`Google reCaptcha: ${ex}`);
            }
        });
        handleSubmitAction();
    }
    ;
    submitPasswordRequest() {
        this.working = true;
        let command = new RequestUserPasswordResetCommand();
        command.requestModel = new UserPasswordResetRequestModel({
            userName: this.userName,
            timezoneOffset: DateHelper.getTimezoneOffset()
        });
        authClient
            .requestPasswordReset(command)
            .then(response => {
            Notifier.onOk(`We will send you a password recovery email if your details match our records.`);
            this.requestReceived = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    // computed
    get statusText() {
        if (this.requestReceived)
            return "Done!";
        return this.working ? "Working..." : "Send recovery email";
    }
    ;
    get recaptchaLoaded() {
        return this.recaptcha != null;
    }
    ;
};
__decorate([
    State("appConfigModule"),
    __metadata("design:type", typeof (_a = typeof AppConfigState !== "undefined" && AppConfigState) === "function" ? _a : Object)
], ForgottenPasswordVue.prototype, "appConfigState", void 0);
ForgottenPasswordVue = __decorate([
    Component({
        name: "ForgottenPasswordVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds } = useForm({
                validationSchema: yup.object({
                    userName: yup.string().trim().required(),
                }),
            });
            const userNameVal = defineInputBinds('userName');
            return {
                errors,
                handleSubmit,
                userNameVal,
            };
        }
    })
], ForgottenPasswordVue);
export default ForgottenPasswordVue;
